import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

/**
 * "Hang up" / end-call glyph — the handset rotated down over signal waves.
 * Pairs with the `Call` (answer) icon in the in-call control bar.
 */
export const CallEndIcon: React.FC<IconProps> = ({
  size = 24,
  color = Colors.role.textStrong,
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 24.8416 24"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path
      d="M5.49373 16.5H2.50192C1.47808 16.5 0.755126 15.497 1.07889 14.5257L1.63067 12.8703C1.8152 12.3167 2.22765 11.8685 2.76399 11.6386C8.93062 8.99578 15.9109 8.99578 22.0776 11.6386C22.6139 11.8685 23.0264 12.3167 23.2109 12.8703L23.7627 14.5257C24.0864 15.497 23.3635 16.5 22.3396 16.5H19.3478C18.7797 16.5 18.2603 16.179 18.0062 15.6708L17.75 15.1584C17.2418 14.142 16.203 13.5 15.0667 13.5H9.77488C8.63856 13.5 7.59977 14.142 7.0916 15.1584L6.83537 15.6708C6.58128 16.179 6.06188 16.5 5.49373 16.5Z"
      stroke={color}
      strokeWidth="2"
    />
  </Svg>
);

CallEndIcon.displayName = 'CallEndIcon';
